import { render } from "./inReviewModal.vue?vue&type=template&id=8d049aa4"
import script from "./inReviewModal.vue?vue&type=script&lang=js"
export * from "./inReviewModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__